/** Follow the actual canvas host as a standalone iOS viewport settles after launch or resume. */
export const observeCanvasViewport = (host: HTMLElement, onResize: () => void): (() => void) => {
    let frame: number | undefined
    const schedule = () => {
        if (frame !== undefined) return
        frame = window.requestAnimationFrame(() => {
            frame = undefined
            onResize()
        })
    }
    const onVisible = () => { if (!document.hidden) schedule() }
    const observer = typeof ResizeObserver === "undefined" ? undefined : new ResizeObserver(schedule)
    observer?.observe(host)
    const viewport = window.visualViewport
    viewport?.addEventListener("resize", schedule)
    window.addEventListener("resize", schedule)
    window.addEventListener("orientationchange", schedule)
    window.addEventListener("pageshow", schedule)
    document.addEventListener("visibilitychange", onVisible)
    // The first measurement can precede the Home Screen app's transition into its final size.
    schedule()

    return () => {
        if (frame !== undefined) window.cancelAnimationFrame(frame)
        observer?.disconnect()
        viewport?.removeEventListener("resize", schedule)
        window.removeEventListener("resize", schedule)
        window.removeEventListener("orientationchange", schedule)
        window.removeEventListener("pageshow", schedule)
        document.removeEventListener("visibilitychange", onVisible)
    }
}
